import { Injectable } from '@angular/core';
import { afterSubmitFormSuccess, FormsService } from '@evorait/pace-forms';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class FormAdapterEffectsService {
    public constructor(
        private actions$: Actions,
        private readonly formsService: FormsService,
    ) {}

    public removeFormSubmitStatus$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(afterSubmitFormSuccess),
                exhaustMap((action) =>
                    this.formsService.removeFormFromCacheCompletely(action.form, action.notification),
                ),
            ),
        {
            dispatch: false,
        },
    );
}
